import { render, staticRenderFns } from "./PartsCatalogueListSideMenu.vue?vue&type=template&id=df947f4e&scoped=true"
import script from "./PartsCatalogueListSideMenu.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PartsCatalogueListSideMenu.vue?vue&type=style&index=0&id=df947f4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df947f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df947f4e')) {
      api.createRecord('df947f4e', component.options)
    } else {
      api.reload('df947f4e', component.options)
    }
    module.hot.accept("./PartsCatalogueListSideMenu.vue?vue&type=template&id=df947f4e&scoped=true", function () {
      api.rerender('df947f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/partscatalogue/PartsCatalogueListSideMenu.vue"
export default component.exports